module.exports = __webpack_public_path__ + "media/images/assignment/add_box-a150e9fb1cdf870b3d8916a4a19342f7.svg";